// 音源の長さ（ミリ秒）を m:ss で表示する。長さ不明（null）の音源は表示しない。
//
// AudioSection のカードと AudioPickerModal の結果リストの両方で使うため lib に置く
// （コンポーネントから export すると Fast Refresh が効かなくなる）。
export const formatAudioDuration = (durationInMs: number | null): string | null => {
  if (durationInMs == null || durationInMs < 0) return null
  const totalSeconds = Math.round(durationInMs / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, "0")}`
}
